import { getTime } from "date-fns";
import { ViolationStatus } from "~/schemas/generated/graphql";
import { dateDifIgnoreWeekends } from "~/libs/dateDifIgnoreWeekends";

export const getViolationRowDecorator = (record: any) => {
  const deadline = record.deadline ? getTime(new Date(record.deadline)) : null;
  const violationDone = record.answerStatus === ViolationStatus.Fixed;
  const workDaysToDeadline = deadline
    ? dateDifIgnoreWeekends(new Date(), deadline) < 0
      ? 0
      : dateDifIgnoreWeekends(new Date(), deadline)
    : null;
  const statusDeleted = record.answerStatus === ViolationStatus.Deleted;

  let className = "";
  if (statusDeleted) {
    className = "rowDeleted";
  } else if (violationDone) {
    className = "rowDone";
  } else if (workDaysToDeadline !== null) {
    if (workDaysToDeadline <= 0) {
      className = "rowCritical";
    } else if (workDaysToDeadline <= 3) {
      className = "rowWarning";
    } else {
      className = "rowNormal";
    }
  }

  return { className };
};
